export const AUDIT_LOG_FEATURE = {
  INVOICING: "INVOICING",
  TRANSACTION_CHANGE: "TRANSACTION_CHANGE",
  TRANSACTION_CATEGORY_CHANGE: "TRANSACTION_CATEGORY_CHANGE",
  TRANSACTION_VENDOR_CHANGE: "TRANSACTION_VENDOR_CHANGE",
  TRANSACTION: "TRANSACTION",
  TASK_CHANGE: "TASK_CHANGE",
  LEDGER_ENTRY: "LEDGER_ENTRY",
  TRANSACTION_PULL: "TRANSACTION_PULL",
  BOOKKEEPING_SETTING_CHANGE: "BOOKKEEPING_SETTING_CHANGE",
  CHART_OF_ACCOUNTANT_CHANGE: "CHART_OF_ACCOUNTANT_CHANGE",
  PLATFORM_CHANGE: "PLATFORM_CHANGE",
  FINANCIAL_CLOSING_CHANGE: "FINANCIAL_CLOSING_CHANGE",
} as const;

export type AuditLogEventType =
  (typeof AUDIT_LOG_FEATURE)[keyof typeof AUDIT_LOG_FEATURE];

export const AUDIT_LOG_FEATURE_OPTIONS = [
  { label: "Invoices", value: AUDIT_LOG_FEATURE.INVOICING },
  {
    label: "Transaction",
    value: AUDIT_LOG_FEATURE.TRANSACTION,
  },
  { label: "Task", value: AUDIT_LOG_FEATURE.TASK_CHANGE },
  { label: "Journal Entry", value: AUDIT_LOG_FEATURE.LEDGER_ENTRY },
  {
    label: "Settings",
    value: AUDIT_LOG_FEATURE.BOOKKEEPING_SETTING_CHANGE,
  },
  {
    label: "Chart of Accounts",
    value: AUDIT_LOG_FEATURE.CHART_OF_ACCOUNTANT_CHANGE,
  },
  { label: "Platform", value: AUDIT_LOG_FEATURE.PLATFORM_CHANGE },
  {
    label: "Financial Closing",
    value: AUDIT_LOG_FEATURE.FINANCIAL_CLOSING_CHANGE,
  },
];

export const AUDIT_LOG_CONTENT_TYPE = {
  TASK: "task",
  COMPANY_GROUP_INVOICE: "companygroupinvoice",
  COMPANY_ENTITY_INVOICE: "customerentityinvoice",
  CHARTS_OF_ACCOUNT: "transactioncategory",
  BOOKKEEPING_SETTINGS: "entitybookkeepingsetting",
  ENTITY_TRANSACTION: "entitytransaction",
  ENTITY_ITEM: "entityitem",
  COMPANY_GROUP_SUBSCRIPTION_DATA: "companygroupsubscriptiondata",
  LEDGER_ENTRY: "ledgerentry",
  CHANNEL: "channel",
} as const;

export type AuditLogContentType =
  (typeof AUDIT_LOG_CONTENT_TYPE)[keyof typeof AUDIT_LOG_CONTENT_TYPE];

export const AUDIT_LOG_USER_TYPE = {
  USER: "User",
} as const;

export const AUDIT_LOG_SOURCE = {
  MANUAL: "MANUAL",
  AI_OR_SYSTEM: "AI_OR_SYSTEM",
} as const;

export type AuditLogSourceType =
  (typeof AUDIT_LOG_SOURCE)[keyof typeof AUDIT_LOG_SOURCE];

export const AUDIT_LOG_SOURCE_OPTIONS = [
  { label: "Manual", value: AUDIT_LOG_SOURCE.MANUAL },
  { label: "AI/System-driven", value: AUDIT_LOG_SOURCE.AI_OR_SYSTEM },
];
